import { render } from "./ForeignerVatRefundPage.vue?vue&type=template&id=169953ae"
import script from "./ForeignerVatRefundPage.vue?vue&type=script&lang=js"
export * from "./ForeignerVatRefundPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__